import React from 'react'
import styles from './styles.module.less'

const Badge = ({ text }) => {
  return <p className={styles.container}>{text}</p>
}

export default Badge
